import React from 'react';

import { createCn } from 'bem-react-classname';
import cn from 'classnames';
import moment from 'moment';
import { Kit } from 'ui/Kit';

import { DashboardMenu } from '../../components/DashboardMenu';
import { KeysUpdatesStatsChart } from '../../components/KeysUpdatesStatsChart';

import './KeysUpdatesStatsPage.scss';

interface Props {}

const cx = createCn('KeysUpdatesStatsPage');

export const KeysUpdatesStatsPage: React.FC = () => {
  return (
    <div className={cn(cx())}>
      <DashboardMenu />

      <Kit.Title>New message keys</Kit.Title>

      <div className={cx('graph')}>
        <KeysUpdatesStatsChart
          fromDate={moment().subtract(12, 'month').format()}
        />
      </div>
    </div>
  );
};
